module.exports = __webpack_public_path__ + "static/media/monitor.65748b14.svg";